/*
 * The transfer types that Slate recognizes.
 */

export const TRANSFER_TYPES = {
    FRAGMENT: 'application/x-slate-fragment',
    HTML: 'text/html',
    NODE: 'application/x-slate-node',
    RICH: 'text/rtf',
    TEXT: 'text/plain',
    VSCODE: 'vscode-editor-data',
};

export const HANDLE_CODE_METADATA = {
    [TRANSFER_TYPES.VSCODE]: {
        getLang: (content: any) => {
            try {
                return JSON.parse(content)?.mode;
            } catch {
                return '';
            }
        },
    },
};

export const TRANSFER_TYPES_CODE = [TRANSFER_TYPES.VSCODE];
